import React from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  LayoutDashboard, 
  User, 
  FileText, 
  Upload, 
  Calendar, 
  CreditCard, 
  Download, 
  LogOut,
  Home
} from 'lucide-react';
import { useAuth } from '../context/AuthContext';

const Sidebar = ({ activeItem }) => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: LayoutDashboard, route: '/dashboard' },
    { id: 'profile', label: 'My Profile', icon: User, route: '/profile' },
    { id: 'application', label: 'My Application', icon: FileText, route: '/application' },
    { id: 'documents', label: 'Upload Documents', icon: Upload, route: '/documents' },
    { id: 'session', label: 'Session Details', icon: Calendar, route: '/session' },
    { id: 'payment', label: 'Payment', icon: CreditCard, route: '/payment' },
    { id: 'idcard', label: 'Download ID Card', icon: Download, route: '/idcard' },
    { id: 'logout', label: 'Logout', icon: LogOut, action: 'logout' }
  ];

  const handleMenuClick = (item) => {
    if (item.action === 'logout') {
      logout();
      navigate('/login');
    } else if (item.route) {
      navigate(item.route);
    }
  };

  return (
    <div className="sidebar-custom h-100" style={{ width: '270px' }}>
      <div className="p-4">
        <div className="d-flex align-items-center mb-4">
          <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: '40px', height: '40px' }}>
            <User className="text-white" size={24} />
          </div>
          <div>
            <h3 className="h6 mb-0 text-dark fw-semibold">Student Portal</h3>
            <p className="small text-muted mb-0">Welcome back!</p>
          </div>
        </div>

        <nav className="mb-4">
          {menuItems.map((item) => {
            const Icon = item.icon;
            return (
              <button
                key={item.id}
                onClick={() => handleMenuClick(item)}
                className={`sidebar-item w-100 mb-2 ${
                  activeItem === item.id ? 'active' : ''
                }`}
              >
                <Icon size={20} className="me-3" />
                <span>{item.label}</span>
              </button>
            );
          })}
        </nav>

        <div className="mt-4 pt-3 border-top">
          <button
            onClick={() => navigate('/')}
            className="sidebar-item w-100"
          >
            <Home size={20} className="me-3" />
            <span>Back to Home</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
